import React, { useEffect, useState } from 'react';
import { Link } from 'react-scroll';
import { ChevronRight } from 'lucide-react';

interface TOCItem {
  id: string;
  text: string;
  level: number;
}

interface TableOfContentsProps {
  content: string;
}

export function TableOfContents({ content }: TableOfContentsProps) {
  const [items, setItems] = useState<TOCItem[]>([]);

  useEffect(() => {
    const doc = new DOMParser().parseFromString(content, 'text/html');
    const headings = Array.from(doc.querySelectorAll('h1, h2, h3'));
    
    const tocItems = headings.map((heading) => ({
      id: heading.id || heading.textContent?.toLowerCase().replace(/\s+/g, '-') || '',
      text: heading.textContent || '',
      level: parseInt(heading.tagName.charAt(1)),
    }));

    setItems(tocItems);
  }, [content]);

  return (
    <nav className="space-y-2">
      <h3 className="font-semibold text-lg mb-4">Table of Contents</h3>
      {items.map((item, index) => (
        <Link
          key={index}
          to={item.id}
          spy={true}
          smooth={true}
          offset={-100}
          duration={500}
          className={`
            block cursor-pointer text-gray-600 hover:text-gray-900
            ${item.level === 1 ? 'font-medium' : ''}
            ${item.level === 2 ? 'pl-4' : ''}
            ${item.level === 3 ? 'pl-8' : ''}
          `}
        >
          <div className="flex items-center py-1">
            <ChevronRight className="w-4 h-4 mr-2" />
            <span>{item.text}</span>
          </div>
        </Link>
      ))}
    </nav>
  );
}